import * as Yup from "yup";
import { GRS_REJECTION_NOTES_MAX_LENGTH } from "constants/grs-pending-leads";

export type TGrsRejectFormValues = {
  rejectionReasonId: number | null;
  notes: string;
};

export const GRS_REJECT_FORM_INITIAL_VALUES: TGrsRejectFormValues = {
  rejectionReasonId: null,
  notes: "",
};

export const grsPendingLeadRejectValidationSchema = Yup.object({
  rejectionReasonId: Yup.number()
    .nullable()
    .required("Please select a rejection reason"),
  notes: Yup.string()
    .trim()
    .max(
      GRS_REJECTION_NOTES_MAX_LENGTH,
      `Notes must be ${GRS_REJECTION_NOTES_MAX_LENGTH} characters or fewer`
    ),
});
